import { create } from "zustand";

export const useMouseStore = create((set) => ({
	xRatio: 0.5,
	yRatio: 0.5,
	setMouse: (x, y) => set(() => ({ xRatio: x, yRatio: y })),
}));
